/**
 * CollectionsHubPage — standalone route for staff granted
 * `collections_uploader` rights (e.g. the accountant). Shows the same
 * upload + overview panes as the Admin tab, from their own login.
 */
import React from 'react';
import CollectionsAdmin from '../components/admin/CollectionsAdmin';

export default function CollectionsHubPage() {
  return (
    <div className="max-w-5xl mx-auto" data-testid="collections-hub-page">
      <CollectionsAdmin />
    </div>
  );
}
